/**
 * @desc 根据id获取单个油价信息
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {
  /** 油价id */
  id?: number
}

export function request(data: QueryParams): Promise<BaseResponse<defs.ResultBean<defs.ResPetrolPrice>>> {
  return fetch({
    url: config.API_HOST + '/base/resPetrolPrice/getDetail',
    params: data,
    method: 'GET',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
